import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { STEPS } from '../utils/constants';

/**
 * Navigazione a step del flusso batch. Accessibile da tastiera: ogni step è un
 * pulsante con `aria-current` sul passo attivo. Gli step raggiungibili sono
 * cliccabili; quelli non ancora sbloccati restano disabilitati.
 */
export default function Stepper({ current, reachable, onSelect }) {
  const currentIndex = STEPS.findIndex((s) => s.id === current);

  return (
    <nav aria-label="Fasi della generazione" className="w-full">
      <ol className="flex flex-wrap items-center gap-1 sm:gap-2">
        {STEPS.map((step, index) => {
          const isActive = step.id === current;
          const isDone = index < currentIndex;
          const canGo = reachable.has(step.id);
          return (
            <li key={step.id} className="flex items-center">
              <button
                type="button"
                onClick={() => canGo && onSelect(step.id)}
                disabled={!canGo}
                aria-current={isActive ? 'step' : undefined}
                className={`flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-gray-100 dark:focus-visible:ring-offset-gray-900 ${
                  isActive
                    ? 'bg-primary text-white shadow-sm'
                    : isDone
                      ? 'text-primary hover:bg-primary/10'
                      : canGo
                        ? 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                        : 'cursor-not-allowed text-gray-400 dark:text-gray-600'
                }`}
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                    isActive
                      ? 'bg-white/25 text-white'
                      : isDone
                        ? 'bg-primary text-white'
                        : 'bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-gray-400'
                  }`}
                >
                  {isDone ? <FaCheck size={10} /> : index + 1}
                </span>
                <span className="hidden sm:inline">{step.label}</span>
                <span className="sm:hidden">{step.short}</span>
              </button>
              {index < STEPS.length - 1 && (
                <span
                  aria-hidden="true"
                  className="mx-0.5 h-px w-3 bg-gray-300 dark:bg-gray-600 sm:w-5"
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
